export default __webpack_public_path__ + "static/media/markopedia-logo.976ab72e.svg";